
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services'
import { StatusMap, StatusPlain } from './config/auth'
import RowItem from '@/components/detail/row_item/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'

@Component({
    name: 'AuthDetail',
    components: {
        RowWrap,
        RowItem
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private statusOption = StatusPlain
    private changeLoading = false
    private detail = {
        status: StatusPlain.Ing.key,
        medium: {},
        user: {}
    }
    private attachFile: any[] = []
    
    get matchStatus() {
        let statusItem = StatusMap.get(this.detail.status)
        return statusItem ? statusItem.value : ''
    }

    private created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    private async mounted() {
        this.isLoading = true
        try {
            await this.getDetail()
        } catch (error) {
            this.$message({ type: 'error', message: '加载失败：' + (error as Error).message })
        } finally {
            this.isLoading = false  // ← 确保一定会执行
        }
    }

    private matchButtonType(status: number) {
        return this.detail.status === status ? 'primary' : 'default'
    }

    /** 获取申请的信息 */
    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        const result = await MediaService.getAuthDetail(params)
        if (result.status === 200) {
            this.detail = result.data
            // 为缺失的对象提供默认值
            if (!this.detail.medium) {
                this.detail.medium = {}
            }
            if (!this.detail.user) {
                this.detail.user = {}
            }
            const mediumName = result.data.medium && result.data.medium.name ? result.data.medium.name : '未知'
            this.$title('媒体认证 | ' + mediumName + ' - 庖丁')
            const { business_license: bl, work_cert_img: wci, id_card_img: ici } = result.data
            this.attachFile = [bl, wci, ici].filter(Boolean)  // ← 过滤空值
        }
    }

    /* 改变状态 */
    private async changeStatus(status: number) {
        this.changeLoading = true
        const params = {
            id: +this.detailId,
            status
        }
        const result = await MediaService.updateAuthStatus(params)
        this.changeLoading = false
        if (result.status === 200) {
            this.detail.status = status
            return this.$msuccess('修改状态成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
